<template>
  <el-dialog
    title="选择时间"
    :visible="timeShow"
    width="1000px"
    center
    :close-on-click-modal="false"
    @close="dialogClose"
    class="disturb-time"
  >
    <div class="content">
      <div class="time-group">
        <span class="title time-title">免打扰时间段</span>
        <span class="title date-title"
          >免打扰周期<el-tooltip
            class="item"
            effect="dark"
            content="右侧按钮为全选按钮"
            placement="right"
          >
            <i class="el-icon-question"></i> </el-tooltip
        ></span>
        <span>
          <el-checkbox-button
            v-for="item in checkAllList"
            :key="item.text"
            :indeterminate="item.isIndeterminate"
            v-model="item.checkAll"
            @change="handleCheckAllChange(item, $event)"
            size="medium"
            ><i class="iconfont icon-quanxuan" style="font-size: 14px"></i
          ></el-checkbox-button>
        </span>
        <span class="iconfont time-add" @click="addTimeClick">&#xe633;</span>
        <span class="iconfont time-reduce" @click="reduceTimeClick">&#xe634;</span>
        <div
          class="time-item"
          v-for="(item, index) in timeList"
          :key="index"
          @click="timeIndexSwicth(index)"
        >
          <span class="text">时间段{{ index + 1 }}</span>
          <div class="time">
            <el-time-picker
              is-range
              v-model="item.timeDate"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              format="HH:mm"
              selectableRange="00:00:00 - 23:59:00"
              :default-value="[new Date(0).setHours(1), new Date(0).setHours(23)]"
            >
            </el-time-picker>
            <el-checkbox-group
              v-model="item.checkList"
              class="checkbox"
              @change="checkboxGroupChange"
            >
              <el-checkbox-button
                :label="item.text"
                v-for="(item, index) in dateList"
                :key="index"
                >{{ item.text }}</el-checkbox-button
              >
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">提 交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    timeShow: {
      type: Boolean,
      default: false,
    },
    selectStuedntList: {
      type: Array,
    },
    deviceDetail: {
      type: Object,
    },
  },
  data() {
    return {
      checkAllList: [
        {
          checkAll: false,
          isIndeterminate: true,
          text: "一",
        },
        {
          checkAll: false,
          isIndeterminate: true,
          text: "二",
        },
        {
          checkAll: false,
          isIndeterminate: true,
          text: "三",
        },
        {
          checkAll: false,
          isIndeterminate: true,
          text: "四",
        },
        {
          checkAll: false,
          isIndeterminate: true,
          text: "五",
        },
        {
          checkAll: false,
          isIndeterminate: true,
          text: "六",
        },
        {
          checkAll: false,
          isIndeterminate: true,
          text: "日",
        },
      ],

      timeIndex: null, // 当设置多个时间段时，获取当前点击时间段的下标
      timeList: [
        {
          time: null,
          timeDate: null,
          // 10:00格式
          timeBegin: "", // 开始时间
          timeEnd: "", // 结束时间
          // 1000 格式
          timeBeginStr: "", // 开始时间
          timeEndStr: "", // 结束时间
          checkList: [],
        },
      ],
      noDisturb: {
        times: [], //免打扰时间段
        days: "", //星期 12345
      },
      dateList: [
        {
          id: 1,
          text: "一",
        },
        {
          id: 2,
          text: "二",
        },
        {
          id: 3,
          text: "三",
        },
        {
          id: 4,
          text: "四",
        },
        {
          id: 5,
          text: "五",
        },
        {
          id: 6,
          text: "六",
        },
        {
          id: 7,
          text: "日",
        },
      ],
      checkList: [], // 选中的星期

      //时间选择器
      timeBeginShow: false,
      timeEndShow: false,

      timeCount: 1,
    };
  },
  methods: {
    // 获取单个设备免打扰赋值
    getSingleDeviceImmunity() {
      // console.log(this.deviceDetail);
      if (this.selectStuedntList.length == 1) {
        this.timeList = this.deviceDetail.timePeriod.map((item) => {
          return (item = {
            timeDate: this.parseTimeString(item.time),
            checkList: this.numberToChineseArray(item.days),
          });
        });

        this.checkboxGroupChange();
      }
    },
    checkboxGroupChange(val) {
      for (let item of this.checkAllList) {
        const checkList = this.timeList.map((itemT) => itemT.checkList);
        const allChecked = checkList.every((list) => list.includes(item.text));

        item.checkAll = allChecked;
        item.isIndeterminate = !allChecked;
      }
    },
    handleCheckAllChange(item, val) {
      item.checkAll = val;
      item.isIndeterminate = false;

      this.timeList.forEach((itemT) => {
        const index = itemT.checkList.indexOf(item.text);
        if (index !== -1) {
          itemT.checkList.splice(index, 1); // 移除 item.text
        }

        if (item.checkAll) {
          itemT.checkList.push(item.text);
        }
      });
      // this.checkedCities = val ? cityOptions : [];
      // this.isIndeterminate = false;
    },
    timeIndexSwicth(i) {
      this.timeIndex = i;
      // console.log(this.timeIndex);
    },
    // 关闭dialog
    dialogClose() {
      this.reset();
      this.$emit("update:timeShow", false);
    },
    // 重置数据
    reset() {
      this.checkAllList.map((item) => (item.checkAll = false));
      (this.timeList = [
        {
          time: null,
          timeDate: null,
          // 10:00格式
          timeBegin: "", // 开始时间
          timeEnd: "", // 结束时间
          // 1000 格式
          timeBeginStr: "", // 开始时间
          timeEndStr: "", // 结束时间
          checkList: [],
        },
      ]),
        (this.noDisturb = {
          times: [], //免打扰时间段
          days: "", //星期 12345
        });
      this.checkList = [];
      this.timeCount = 1;
    },
    submit() {
      // 时间段为空
      if (!this.timeList[this.timeList.length - 1].timeDate)
        return this.$message.warning("请选择时间段的时间");
      // 免打扰周期为空
      if (this.timeList[this.timeList.length - 1].checkList.length == 0) {
        return this.$message.warning("免打扰周期不能为空");
      }

      let submitList = [];
      let timePeriod = [];
      this.timeList.forEach((item) => {
        timePeriod.push({

          time: `${this.formatTime(new Date(item.timeDate[0]))}-${this.formatTime(
            new Date(item.timeDate[1])
          )}`,
          days: this.convertAndSortDaysOfWeek(item.checkList),
        });
      });

      submitList = this.selectStuedntList.map((item) => {
        return (item = {
          deviceId: item,
          timePeriod,
        });
      });

      // console.log("submitList==>", submitList);
      this.$emit("submit", submitList);
    },

    // time字符串转为date格式日期数组
    parseTimeString(timeString) {
      // 检查字符串是否为有效格式
      const timeRegex = /^(\d{2})(\d{2})-(\d{2})(\d{2})$/;
      const match = timeString.match(timeRegex);

      if (!match) {
        throw new Error("无效的时间格式");
      }

      // 提取小时和分钟部分
      const [, startHour, startMinute, endHour, endMinute] = match;

      // 创建日期对象
      const startDate = new Date();
      startDate.setHours(Number(startHour));
      startDate.setMinutes(Number(startMinute));

      const endDate = new Date();
      endDate.setHours(Number(endHour));
      endDate.setMinutes(Number(endMinute));

      // 返回包含两个日期的数组
      return [startDate, endDate];
    },

    // 时间段补0
    formatTime(date) {
      return `${date.getHours() < 10 ? "0" : ""}${date.getHours()}${
        date.getMinutes() < 10 ? "0" : ""
      }${date.getMinutes()}`;
    },

    // 字符串转星期数组
    numberToChineseArray(numberStr) {
      const chineseDigits = ["一", "二", "三", "四", "五", "六", "七", "八", "九"];
      const result = [];

      for (let i = 0; i < numberStr.length; i++) {
        const digit = parseInt(numberStr[i]);
        if (!isNaN(digit) && digit > 0 && digit <= 9) {
          result.push(chineseDigits[digit - 1]);
        }
      }

      return result;
    },

    // 星期转换字符串
    convertAndSortDaysOfWeek(daysOfWeek) {
      const romanNumerals = {
        一: "1",
        二: "2",
        三: "3",
        四: "4",
        五: "5",
        六: "6",
        日: "7",
      };

      // 将文本转换为罗马数字字符串
      const romanNumeralsArray = daysOfWeek.map((day) => romanNumerals[day]);

      // 升序排列
      romanNumeralsArray.sort();

      // 将数组合并为字符串
      const result = romanNumeralsArray.join("");

      return result;
    },

    // 添加时间阶段
    addTimeClick() {
      if (this.timeList.length == 7) return this.$message.warning("最多设置7个时间段！");
      this.timeList = [
        ...this.timeList,
        {
          time: null,
          // 10:00格式
          timeBegin: "", // 开始时间
          timeEnd: "", // 结束时间
          // 1000 格式
          timeBeginStr: "", // 开始时间
          timeEndStr: "", // 结束时间
          beginTime: "开始时间",
          endTime: "结束时间",
          checkList: [],
        },
      ];
      this.checkAllList.forEach((item) => {
        item.checkAll = false;
      });
    },
    // 减少时间阶段
    reduceTimeClick() {
      if (this.timeList.length == 1) {
        return this.$message.warning("至少设置1个时间段");
      }
      this.timeList.pop(); // 删除最后一条数据
      this.checkboxGroupChange();
    },
    // 将10:00和11:00 转换成 1000-1100 格式
    changeTime(begin, end) {
      let beginStr = begin.replace(":", "");
      let endStr = end.replace(":", "");
      return `${beginStr}-${endStr}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./disturb-time.scss";
</style>
